import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ProductDetail from './pages/ProductDetail';
import Wallet from './pages/Wallet';
import Orders from './pages/Orders';
import AdminDashboard from './pages/AdminDashboard';
import SellerKYB from './pages/SellerKYB';
import SellerDashboard from './pages/SellerDashboard';
import SellerWallet from './pages/SellerWallet';
import SellerAnalytics from './pages/SellerAnalytics';
import StoreFront from './pages/StoreFront';
import Checkout from './pages/Checkout';
import Cart from './pages/Cart';
import VTU from './pages/VTU';
import Profile from './pages/Profile';
import LoyaltyPoints from './pages/LoyaltyPoints';
import SupportPage from './pages/SupportPage';
import CSDashboard from './pages/CSDashboard';
import FiatWithdrawal from './pages/FiatWithdrawal';
import CommissionPage from './pages/CommissionPage';

function ProtectedRoute({ children, adminOnly=false, sellerOnly=false, csOnly=false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" />;
  if (sellerOnly && user.role !== 'seller') return <Navigate to="/" />;
  if (csOnly && !['admin','cs_staff'].includes(user.role)) return <Navigate to="/" />;
  return children;
}

function AppRoutes() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/store/:username" element={<StoreFront />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
        <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
        <Route path="/kyb" element={<ProtectedRoute><SellerKYB /></ProtectedRoute>} />
        <Route path="/seller" element={<ProtectedRoute sellerOnly><SellerDashboard /></ProtectedRoute>} />
        <Route path="/seller/wallet" element={<ProtectedRoute sellerOnly><SellerWallet /></ProtectedRoute>} />
        <Route path="/seller/analytics" element={<ProtectedRoute sellerOnly><SellerAnalytics /></ProtectedRoute>} />
        <Route path="/seller/withdraw" element={<ProtectedRoute sellerOnly><FiatWithdrawal /></ProtectedRoute>} />
        <Route path="/vtu" element={<ProtectedRoute><VTU /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/rewards" element={<ProtectedRoute><LoyaltyPoints /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
        <Route path="/cs" element={<ProtectedRoute csOnly><CSDashboard /></ProtectedRoute>} />
        <Route path="/commission" element={<CommissionPage />} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
      </Routes>
      <BottomNav />
      <Toaster position="top-center" toastOptions={{ style:{ background:'#12121A', color:'#E0E0F0', border:'1px solid #1E1E2E' }, success:{ iconTheme:{ primary:'#FF6B00', secondary:'#0A0A0F' } } }} />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
